import uniqueId from 'lodash.uniqueid';

import template from './svg.html' with { type: 'html' };

export default {
	name: 'CSvg',
	props: {
		href: {
			type: String,
			required: true
		},
		title: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			titleId: null
		};
	},
	mounted() {
		this.titleId = uniqueId('title_');
	},
	template
};
